import { render } from "./followersPage.vue?vue&type=template&id=4bec332e"
import script from "./followersPage.vue?vue&type=script&lang=js"
export * from "./followersPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__